import {showPopupMessage} from '@utils/popupMessage/PopupMessageService';
import {
    TriggerClientAutobooking, TriggerEventAutobooking, TriggerEventContentAutobooking, TriggerPropertyLicenceAutobooking,
} from '@graphql/autobooker/mutation';

import client from '../../../apolloClient';

const mapEntityToMutation = (entity) => {
    switch (entity) {
        case 'client':
            return TriggerClientAutobooking;
        case 'event':
            return TriggerEventAutobooking;
        case 'content':
            return TriggerEventContentAutobooking;
        case 'property licence':
            return TriggerPropertyLicenceAutobooking;
        default:
            throw `Attempt to trigger autobooker for undefined type: ${entity}`;
    }
};

export const triggerAutobooker = (id, entity, messageBoxName, MessageBox, Modal) => {
    client.mutate({
        mutation: mapEntityToMutation(entity),
        variables: {
            id: id,
        },
    }).then(() => {
        showPopupMessage(
            `The Autobooker / Auto-offerer have been triggered successfully for this ${entity}.
            It may take up to 30 seconds before they finish their execution. Be patient!`,
            'success'
        );
    }).catch((error) => {
        showPopupMessage(
            'The Autobooker / Auto-offerer could not be triggered.',
            'error',
            true,
            `${error}`
        );
    }).finally(() => Modal.setModal({isVisible: false}));
};
